var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
import { getCanvasPrintProduct } from "./canvasPrintLoader";
import { ProductType } from "../configs/vortexProductConfig";
import { getFlatSheetProduct } from "./flatSheetLoader";
import { getModelProduct } from "./modelLoader";
import { getNfoldProduct } from "./nFoldLoader";
/**
 * Loads a vortex product from a vortex product configuration payload. If the product fails to load, this function will throw an error.
 */
export function loadProduct(vortexProductConfig) {
  return __awaiter(this, void 0, void 0, function* () {
    switch (vortexProductConfig.type) {
      case ProductType.flatSheet:
        {
          return getFlatSheetProduct(vortexProductConfig);
        }
      case ProductType.model:
        {
          return getModelProduct(vortexProductConfig);
        }
      case ProductType.nFold:
        {
          return getNfoldProduct(vortexProductConfig);
        }
      case ProductType.canvasPrint:
        {
          return getCanvasPrintProduct(vortexProductConfig);
        }
      default:
        throw new Error("Unsupported product type '".concat(vortexProductConfig.type, "'!"));
    }
  });
}
const MODEL_CONFIG_URL = "https://cdn.previews.cimpress.io/v2/modelConfig";
/**
 * Queries the vortex orchestration service for a vortex product configuration given a sku, variables, and tenant.
 * If no vortex product configuration is found, this function will throw an error.
 */
export function getProductConfig(options) {
  return __awaiter(this, void 0, void 0, function* () {
    var _a;
    const attributes = JSON.stringify(options.attributes);
    let queryUrl = "".concat(MODEL_CONFIG_URL, "?sku=").concat(options.sku, "&skuAttributes=").concat(encodeURIComponent(attributes)) + "&tenantId=".concat(options.tenant.id, "&tenantType=").concat(options.tenant.type);
    if (options.ignoreLinkedModels) {
      queryUrl += "&ignoreVortexModel=".concat(options.ignoreLinkedModels);
    }
    if (options.version) {
      queryUrl += "&version=".concat(options.version);
    }
    const response = yield fetch(queryUrl);
    if (!response.ok) {
      if ((_a = response.headers.get("content-type")) === null || _a === void 0 ? void 0 : _a.includes("application/json")) {
        const data = yield response.json();
        throw new Error("Failed to fetch vortex product config: '".concat(JSON.stringify(data), "}'!"));
      }
      throw new Error("Failed to fetch vortex product config!");
    }
    const vortexResponse = yield response.json();
    return vortexResponse;
  });
}